// extracted by mini-css-extract-plugin
module.exports = {"coverPath":"BaseInfo_style_coverPath__LYba-"};